export const b64toBlob = async (
  base64: string,
  type = 'application/octet-stream',
): Promise<Blob> =>
  fetch(`data:${type};base64,${base64}`).then(async res => res.blob());
